
/**
 * Export `contactSubjectType`.
 */

export const contactSubjectType = {
  sampleRequest: 'sample request',
  visitScheduling: 'visit scheduling',
  requestForInformation: 'request for information' // eslint-disable-line sort-keys
} as const;
